import script from "./AuthenticatedLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthenticatedLayout.vue?vue&type=script&setup=true&lang=js"

import "./AuthenticatedLayout.vue?vue&type=style&index=0&id=1a22ab54&lang=scss&scoped=true"

import exportComponent from "/builds/pfir/pfir-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a22ab54"]])

export default __exports__